import { render, staticRenderFns } from "./modalServicosAgendaPorHorario.vue?vue&type=template&id=4a0c0ed7"
import script from "./modalServicosAgendaPorHorario.vue?vue&type=script&lang=js"
export * from "./modalServicosAgendaPorHorario.vue?vue&type=script&lang=js"
import style0 from "./modalServicosAgendaPorHorario.vue?vue&type=style&index=0&id=4a0c0ed7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports